import { css, Theme } from '@emotion/react'
import { Container } from '@mui/material'

import { PostQuery, HomepostsQuery } from '../../../generated/graphql.api'

import BlogHead from '~/components/organisms/BlogHead'
import BlogBody from '~/components/organisms/BlogBody'
import BlogRelated from '~/components/organisms/BlogRelated'

type Props = {
  data: PostQuery
  related: HomepostsQuery
}

const BlogPageTemplate: React.FC<Props> = ({ data, related }) => {
  const { coverImage, title, date, content, category, publishedAt, updatedAt } =
    data.values

  return (
    <>
      <Container component='article' css={styles.container} disableGutters>
        <BlogHead
          title={title}
          date={date}
          publishedAt={publishedAt}
          updatedAt={updatedAt}
          width={coverImage.width}
          height={coverImage.height}
          url={coverImage.url}
          filename={coverImage.fileName}
          category={category}
        />
        <BlogBody content={content} />
        <BlogRelated related={related} />
      </Container>
    </>
  )
}

const styles = {
  container: css`
    width: 100%;
    @media (min-width: 960px) {
      width: 870px;
    }
  `,
}

export default BlogPageTemplate
